<template>
    <div>
        <el-form :inline="true" :model="search" @submit.native.prevent>

            <el-form-item label="任务编号：" >
                <el-input v-model.trim="search.taskNo"  clearable></el-input>
            </el-form-item>

            <el-form-item label="供应商：">
                <el-select v-model="search.supplierCode" placeholder="请选择" clearable filterable>
                    <el-option v-for="item in branchSupplierOption" :value="item.id" :key="item.id" :label="item.name"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" plain icon="el-icon-search" @click="searchFluxPollList()">查 询</el-button>
                <el-button type="success" plain @click="getFluxPollListHandler()">刷 新</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData"
		  border
		  fit
		  highlight-current-row
		  style="width: 100%;"
		  :header-cell-style="{background:'#f5f5f5'}"
		  height="651" >
            <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
            <el-table-column prop="taskNo" label="任务编号" align="center"></el-table-column>
            <el-table-column prop="taskName" label="任务名称" align="center"></el-table-column>
            <el-table-column prop="pollingCount" label="轮询总数" align="center"></el-table-column>
            <el-table-column prop="pollingedCount" label="已轮询数" align="center"></el-table-column>

            <el-table-column label="轮询停机" align='center'>
                <el-table-column prop="successCount" label="成功数量" width="90" align="center"></el-table-column>
                <el-table-column prop="faileCount" label="失败数量" width="90" align="center"></el-table-column>
                <el-table-column label="未停机数量" width="90" align="center">
                    <template slot-scope="scope">
                        {{scope.row.pollingCount - scope.row.successCount - scope.row.faileCount}}
                    </template>
                </el-table-column>
            </el-table-column>
			<el-table-column prop="limitSpeedCount" label="限速数量" width="100" align="center"></el-table-column>
            <el-table-column prop="startTime" label="开始轮询时间" align="center"></el-table-column>
            <el-table-column prop="endTime" label="结束轮询时间" align="center"></el-table-column>
            <el-table-column label="操作" width="100" align="center" fixed="right">
                <template slot-scope="scope">
                    <a href="javascript:void(0);" @click="showDetail(scope.row.taskNo)">查看详情</a>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500,2000,5000,10000]"
            :page-size="tbpg.pageSize"
			background
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>

    </div>
</template>
<script>
import {getFluxPollList, getFluxPollDetail, exportFluxPollDetail, } from '@/api/sim.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            search:{
                taskNo:null,
                supplierCode:null,
            },
            branchSupplierOption: [],

            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
        }
    },
    methods: {  

        getFluxPollListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.search);
            getFluxPollList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },

        searchFluxPollList(){
            this.tbpg.currentPage = 1;
            this.getFluxPollListHandler();
        },


        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getFluxPollListHandler();
        },

        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getFluxPollListHandler();
        },

        //详情表

        showDetail(taskNo){
            this.$store.commit('menu/setFluxPollDetailIccid', "");
            this.$store.commit('menu/setFluxPollDetailTaskNo', taskNo);

            if (!this.$store.state.menu.isFluxPollDetailTab) {
                let newTab = {
                    label: '流量轮询详情',
                    index: 'fluxPollDetail',
                    closable: true,
                    component: "views/monitor/fluxPollDetail"
                }
                this.$store.commit('menu/addTab', newTab);
                this.$store.commit('menu/setIsFluxPollDetailTab', true);
            }
            this.$store.commit('menu/switchTab', 'fluxPollDetail')
        },

    },
    created () {
        common.sysRequest('sim/supplier/list', {}, 'post').then(res => {
            if(res.data.code == 200){
                for(let i=0; i<res.data.data.length; i++){
                    if(res.data.data[i].state == 1){
                        this.branchSupplierOption.push(res.data.data[i]);
                    }
                }
            }
        });
        
        this.getFluxPollListHandler();

    }
}
</script>
<style>

</style>
